/**
 * Maps a generate-training-quiz failure to a readable admin message (Phase Q1).
 * Keeps the manager-facing copy honest and specific without exposing internals.
 */
export function mapQuizGenError(
  status: number | undefined,
  fallback = 'Quiz generation failed. Please try again.',
): string {
  if (status === 401 || status === 403) {
    return 'You must be a manager/admin to generate quizzes.';
  }
  if (status === 422) {
    return 'Transcript too short or unavailable for a quiz.';
  }
  if (status === 400) {
    return 'Missing artifact — cannot generate a quiz.';
  }
  return fallback;
}
